import { Stack, Typography } from "@mui/material";
import React from "react";
import { OperationRequestType } from "../../../Core/Api/Types/operation-request-type";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { useTranslation } from "react-i18next";

export interface TableCellApprovalRequestProps {
  data: { value: { type: OperationRequestType; description: string } };
}

const TableCellApprovalRequest: React.FC<TableCellApprovalRequestProps> = ({ data }) => {
  const { t } = useTranslation();
  const Title = () => {
    switch (data.value.type) {
      case "SwitchClassToRaw":
        return (
          <>
            <CompareArrowsIcon color="primary" />
            <Typography color="primary.main">{t("table:cellTitle.switchClassToRaw")}</Typography>
          </>
        );
      case "SwitchClassToMezz":
        return (
          <>
            <CompareArrowsIcon color="primary" />
            <Typography color="primary.main">{t("table:cellTitle.switchClassToMezz")}</Typography>
          </>
        );
      case "CopyAsset":
        return (
          <>
            <ContentCopyIcon color="info" />
            <Typography color="info.main">{t("common:copy")}</Typography>
          </>
        );
      case "ProxyError":
        return (
          <>
            <ErrorOutlineIcon color="error" />
            <Typography color="error">{t("table:cellTitle.proxyError")}</Typography>
          </>
        );
      case "BypassAssetRejection":
        return (
          <>
            <DoneAllIcon color="success" />
            <Typography color="success.main">{t("table:cellTitle.bypassAssetRejection")}</Typography>
          </>
        );
      case "MoveAsset":
        return (
          <>
            <DriveFileMoveIcon color="info" />
            <Typography color="info.main">{t("common:move")}</Typography>
          </>
        );
      case "DeleteAssetRequest":
        return (
          <>
            <DeleteForeverOutlinedIcon color="error" />
            <Typography color="error">{t("common:delete")}</Typography>
          </>
        );
      case "PurgeAssetRequest":
        return (
          <>
            <DeleteForeverOutlinedIcon color="error" />
            <Typography color="error">{t("common:purge")}</Typography>
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <Stack spacing={0.5} mt={0.5} mb={0.5}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Title />
      </Stack>
      <Typography
        title={data.value.description}
        variant="body2"
        color="text.tier"
        sx={{ wordBreak: "break-word", wordWrap: "break-word" }}
      >
        {data.value.description}
      </Typography>
    </Stack>
  );
};

export default TableCellApprovalRequest;
